import { createContext, useEffect, useState } from 'react';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';
import { TabKeyEnum } from '..';
import { UserEffectComponent } from './UserEffectComponent';
import { RoleEffectComponent } from './RoleEffectComponent';
import { ClassEffectComponent } from './ClassEffectComponent';
import MfaList from './MfaList/MfaList';

// ユーザー管理タブと同じ ListContext の型定義
type ListContextType = {
    classList: SchoolClass[];
    classListItemCount: number;
    classListMap: Record<string, SchoolClass[]>;
    classListMapItemCount: Record<string, number>;
    classListMapListCount: number;
    organizationList: Organization[];
    organizationListItemCount: number;
    roleList: Role[];
    roleListItemCount: number;
    usersList: User[];
    usersListItemCount: number;
};

// MFA管理画面用 ListContext
export const ListContext = createContext<UseStateType<ListContextType>>([
    {
        classList: [],
        classListItemCount: 0,
        classListMap: {},
        classListMapItemCount: {},
        classListMapListCount: 0,
        organizationList: [],
        organizationListItemCount: 0,
        roleList: [],
        roleListItemCount: 0,
        usersList: [],
        usersListItemCount: 0,
    },
    () => undefined,
]);

type Props = {
    tabActiveKey: (typeof TabKeyEnum)[keyof typeof TabKeyEnum];
    hasTouchScreen: boolean;
};

// MFA管理画面
const MfaManagement: React.FC<Props> = (props) => {
    const [list, setList] = useState<ListContextType>({
        classList: [],
        classListItemCount: 0,
        classListMap: {},
        classListMapItemCount: {},
        classListMapListCount: 0,
        organizationList: [],
        organizationListItemCount: 0,
        roleList: [],
        roleListItemCount: 0,
        usersList: [],
        usersListItemCount: 0,
    });
    const isControllableUser = useAppSelector(
        (state) => state.isControllableUser,
    );
    const organizationSearchConnection = useAppSelector(
        (state) => state.organizationSearchConnection,
    );
    const dispatch = useDispatch();

    // コントロールユーザの場合、学校一覧を取得する
    useEffect(() => {
        if (!isControllableUser.payload) return;
        dispatch(
            Actions.http.connection.organization.search(
                { page_size: 10000 },
                1,
                '',
            ),
        );
    }, [dispatch, isControllableUser.payload]);

    useEffect(() => {
        if (
            organizationSearchConnection.meta.status ===
            Actions.statusEnum.SUCCESS
        ) {
            setList((prev) => ({
                ...prev,
                organizationList:
                    organizationSearchConnection.payload.result.items,
                organizationListItemCount:
                    organizationSearchConnection.payload.result.item_count,
            }));
        }
    }, [organizationSearchConnection]);

    return (
        <ListContext.Provider value={[list, setList]}>
            <UserEffectComponent />
            <RoleEffectComponent />
            <ClassEffectComponent />
            <MfaList
                tabActiveKey={props.tabActiveKey}
                hasTouchScreen={props.hasTouchScreen}
            />
        </ListContext.Provider>
    );
};

export default MfaManagement;
